import Vue from 'vue';
import { getProfile } from '../../../services/personnelService/qrCodeService';
import { changeProfilePicture } from '../../../services/backendService/profileService';
import { changeProfilePreferredName, changeProfileAutoReplyMessage, changeProfile } from '../../../services/personnelService/profileService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  data: null,
  profileImgUrl: null,
  skillList: []
};

// getters
const getters = {};

// actions
const actions = {
  // 取得顧問 Profile
  async getProfileHandler({ commit }) {
    const data = await getProfile();
    commit('setData', data.data);
  },
  async changeProfilePictureHandler({ commit }, formData) {
    const data = await changeProfilePicture(formData);
    commit('setProfileImgUrl', data);
  },
  //修改顧問名稱
  async changeProfilePreferredNameHandler({ commit }, formData) {
    await changeProfilePreferredName(formData);
  },
  //修改自動回覆
  async changeProfileAutoReplyMessageHandler({ commit }, formData) {
    await changeProfileAutoReplyMessage(formData);
  },
  //更改顧問profile(統整修改: 顧問名稱 + 自動回覆 + 專業技能)
  async changeProfile({ commit }, formData) {
    await changeProfile(formData);
  }
};

// mutations
const mutations = {
  setData(state, data) {
    Vue.set(state, 'data', data.personnel);
    Vue.set(state, 'skillList', data.skill_list);
    Vue.set(state, 'profileImgUrl', data.personnel.picture_url);
  },
  setProfileImgUrl(state, data) {
    Vue.set(state, 'profileImgUrl', data.data.picture_url);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
